<template>
  <Statistic />
</template>

<script>
import Statistic from '@/components/statistic/index.vue'

export default {
  name: 'Statistics',
  components: { Statistic }
}
</script>

<style scoped>

</style>
